/**
 * Determines if a given print product is considered a standard print
 *
 * @param {Object} printProduct the print product
 *
 * @returns {boolean}
 */
export const isStandardPrint = printProduct => {
  if (!printProduct) {
    return false;
  }

  return printProduct.is_standard || printProduct.name === 'Standard Prints';
};
